import React from 'react';
import { Box } from '@mui/material';

const whatGameSpSrc = `${process.env.PUBLIC_URL}/top/TopWhatGame/what_game_sp.webp`;
const assetBasePath = `${process.env.PUBLIC_URL}/top/TopWhatGame`;

const steps = [
  {
    step: 'STEP 1',
    title: '参加するルームを選ぶ',
    imageSrc: `${assetBasePath}/step01-room-card.png`,
    imageAlt: '開催中ルームカードと参加ボタン',
    note: '気になるルームを見つけたら、カードから参加へ進みます。',
  },
  {
    step: 'STEP 2',
    title: 'ルールを確認して参加する',
    imageSrc: `${assetBasePath}/step02-join-dialog.png`,
    imageAlt: 'ルーム参加ダイアログ',
    note: '参加条件とルールを確認して、ルームに参加します。',
  },
  {
    step: 'STEP 3',
    title: '予想とポイントを選んでベット',
    imageSrc: `${assetBasePath}/step03-bet-controls.png`,
    imageAlt: 'ベット予定とベット操作',
    note: 'ポイントを選ぶとベット予定に反映され、予想を確定できます。',
  },
];

const stepCardSx = {
  width: '100%',
  p: '14px',
  borderRadius: '8px',
  border: '1px solid rgba(25, 118, 210, 0.18)',
  bgcolor: '#fff',
  boxSizing: 'border-box',
  boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
};

const stepLabelSx = {
  display: 'inline-flex',
  alignItems: 'center',
  px: '9px',
  py: '4px',
  borderRadius: '999px',
  bgcolor: '#e3f2fd',
  color: '#0d47a1',
  fontSize: '12px',
  fontWeight: 900,
  lineHeight: 1,
};

function StepCard({ item }) {
  return (
    <Box sx={stepCardSx}>
      <Box sx={stepLabelSx}>
        {item.step}
      </Box>
      <Box
        component="h3"
        sx={{
          m: '9px 0 10px',
          color: '#061a3a',
          fontSize: '20px',
          fontWeight: 900,
          lineHeight: 1.35,
        }}
      >
        {item.title}
      </Box>
      <Box
        component="img"
        src={item.imageSrc}
        alt={item.imageAlt}
        sx={{
          display: 'block',
          width: '100%',
          maxWidth: 430,
          mx: 'auto',
          height: 'auto',
          borderRadius: '8px',
          border: '1px solid rgba(15, 23, 42, 0.1)',
        }}
      />
      <Box
        sx={{
          mt: '10px',
          color: 'rgba(6, 26, 58, 0.76)',
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: 1.6,
        }}
      >
        {item.note}
      </Box>
    </Box>
  );
}

function TopWhatGameSP() {
  return (
    <Box
      sx={{
        mx: 0,
        mt: 1,
        mb: 1.5,
        boxSizing: 'border-box',
      }}
    >
      <Box
        component="img"
        src={whatGameSpSrc}
        alt="どんな話題も、予想ゲームになる"
        sx={{
          display: 'block',
          width: '100%',
          maxWidth: 'none',
          height: 'auto',
        }}
      />
      <Box
        sx={{
          mx: 1.5,
          mt: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.25,
        }}
      >
        {steps.map((item, index) => (
          <React.Fragment key={item.step}>
            <StepCard item={item} />
            {index < steps.length - 1 && (
              <Box
                aria-hidden="true"
                sx={{
                  color: '#1976d2',
                  fontSize: '28px',
                  fontWeight: 900,
                  lineHeight: 1,
                  textAlign: 'center',
                }}
              >
                ↓
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}

export default TopWhatGameSP;
